"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";

/**
 * Thin wrapper that provides the posthog-js singleton (initialized in
 * instrumentation-client.ts) to the React tree so usePostHog() works.
 */
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return <PHProvider client={posthog}>{children}</PHProvider>;
}
